var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPoweredBy)?_c('div',{staticClass:"octadesk-app-powered-by",class:{
    'conversation-offset': _vm.inConversationRoute,
    'reset--z-index conversation': _vm.inConversationRoute,
    'kb-enabled': _vm.showKbCard
  }},[_c('a',{attrs:{"href":_vm.poweredByLink,"target":"_system"}},[_c('svg',{attrs:{"viewBox":"0 0 111 111","width":"111","height":"111"}},[_c('use',{attrs:{"xlink:href":"#octa-logo"}})]),_c('span',{staticClass:"poweredBy"},[_vm._v(_vm._s(_vm.$t('poweredBy')))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }